// extracted by mini-css-extract-plugin
export default {"container":"ba396475e6914beb","modal":"_80f53b901d9a675d","cursor":"_4aa95fe35336de4e"};